import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

/**
 * Close / clear cross. Always decorative: the accessible name belongs on the
 * wrapping button, so this stays out of the accessibility tree entirely.
 *
 * There is deliberately no labelled variant. The earlier one set `role="img"`
 * + `aria-label` on the `<svg>`; no caller ever used it, and the role tripped
 * SonarQube S6819. If a standalone labelled icon is ever needed, give the
 * wrapping control the label rather than reintroducing a role here.
 */
const IconClose: React.FC<IconProps> = ({ size = 14, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M18 6 6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default IconClose;
